import List from "../../../components/LanguageManagement/List/List";
import ModalAddLanguage from "../../../components/LanguageManagement/ModalAddLanguage";
import AddIcon from "@mui/icons-material/Add";
import { Grid, IconButton } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import styles from "./LanguageManagement.module.scss";

const LanguageManagement = () => {
  const params: any = useParams();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickAdd = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  return (
    <>
      <div className={styles.MenuNavWrapper}>
        <Grid container className={styles.MenuNav} alignItems={"flex-end"}>
          {/* {MENU?.map((item: any, index: any) => ( 
            // <NavLink
            //   key={index}
            //   to={item?.path}
            //   className={styles.MenuItem}
            //   // activeClassName={styles.MenuItemActive}
            // >*/}
              <span
                className={styles.MenuItemActive}
              >
                Danh sách
              </span>
            {/* </NavLink> */}
          {/* ))} */}
          <IconButton
            color="primary"
            aria-label="add"
            className={styles?.AddButton}
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickAdd}
          >
            <AddIcon style={{ color: "#fff" }} />
          </IconButton>
          <ModalAddLanguage anchorEl={anchorEl} open={open} handleClose={handleClose} />
        </Grid>
      </div>
      {params.type === "/admin/language-management/list" && <List />}
    </>
  );
};

// export default WithAuth(LanguageManagement);
export  default LanguageManagement
